import React from "react";

/**
 * Renders a JSON-LD <script> tag for SEO structured data.
 * Google indexes this for rich-result eligibility (breadcrumbs, products, organization).
 */
export default function JsonLd({ data }) {
  if (!data) return null;
  // Escape '<' and '>' so a malicious string can't break out of the <script> tag.
  // Standard hardening pattern for JSON-LD in React.
  const safeJson = JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  );
}

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://mileforge.in";

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "MileForge",
  alternateName: "Mile Forge",
  slogan: "Forged Through Miles",
  url: SITE_URL,
  logo: `${SITE_URL}/mileforge-logo.png`,
  sameAs: [
    "https://instagram.com/mileforge",
    "https://instagram.com/touringcraft",
    "https://rides.touringcraft.com",
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+91-98840-41979",
      email: "hello@mileforge.in",
      contactType: "customer support",
      areaServed: "IN",
      availableLanguage: ["en"],
    },
  ],
  address: {
    "@type": "PostalAddress",
    addressCountry: "IN",
  },
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "MileForge",
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/shop?search={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};
